import { Router } from '@angular/router';

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import { ITEMS_TYPES } from '@ispm/dynamic-form/constants/ItemsTypes';
import { FormHandlerService } from '@ispm/dynamic-form/services/form-handler.service';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { ExternalAction, IExternalAction } from '../interfaces/external-action.interface';
import { ExternalCompleteWorkflow } from '../services/external-completeworkflow.service';
import { ExternalFileDownloadService } from '../services/external-file-download.service';
import { RouterManagerService } from '@ispm/core/services/router-manager.service';

@Component({
  selector: 'gen-external-action',
  template: '<h3>{{messageText}}</h3>',
  styleUrls: ['./external-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ExternalActionComponent implements OnInit {

  private readonly action: string;
  private readonly payload: string;
  messageText = '';

  constructor(
    private authService: AuthenticationService,
    private externalCompleteWorkflow: ExternalCompleteWorkflow,
    private externalFileDownload: ExternalFileDownloadService,
    private formHandler: FormHandlerService,
    private router: Router,
    private routerManagerService: RouterManagerService,
  ) {
    this.action = this.routerManagerService.parameters.action;
    this.payload = this.routerManagerService.queryParameters.payload;
  }

  ngOnInit() {
    if (!this.checkAuth()) {
      this.popupDynamicFormModal('Please authorize');
    } else {
      this.handleAction(this.action, this.payload).then();
    }
  }

  checkAuth() {
    // check if user is already authenticated
    let user = this.authService.getUser();
    let ttl = document.cookie.match(/^(.*;)?\s*LC_[-.0-9a-zA-Z]+_[a-zA-Z0-9]+\s*=\s*[^;]+(.*)?$/);
    if (ttl && user) {
      return this.authService.checkSession().then(this.handleAction(this.action, this.payload)).catch(() => {
        return null;
      });
    }
    return false;
  }

  auth(loginId: string, password: string) {
    this.authService.login({ loginId, password })
      .subscribe(
        () => {
          console.log('Logged in');
          return this.handleAction(this.action, this.payload);
        },
        () => {
          this.popupDynamicFormModal('Invalid credentials. Please try again');
        }
      )
  }

  async handleAction(action, payload) {
    if (this.action) {
      let handler: IExternalAction;
      switch (this.action.toLowerCase()) {
        case ExternalAction.DOWNLOAD:
          handler = this.externalFileDownload;
          break;
        case ExternalAction.COMPLETEWORKFLOW:
          handler = this.externalCompleteWorkflow;
          break;
        default:
          console.error('unsupported action: ' + this.action);
          throw new Error('UNSUPPORTED_ACTION: ' + this.action)
      }
      try {
        this.messageText = handler.messageText;
        return await handler.handleAction(this.payload);
      } catch (e) {
        this.handleException();
      }
    } else {
      // action not specified
      throw new Error('ACTION_NOT_SPECIFIED');
    }
  }

  handleException() {
    this.router.navigate(['/unauthorized']).then();
  }

  popupDynamicFormModal(title: string) {
    return this.formHandler.popupDynamicFormModal(title, [
        DynamicFormItem.builder('email (login)', 'loginId', ITEMS_TYPES.TEXT).setAttributes({ '[forceFormMode]': true }),
        DynamicFormItem.builder('password', 'password', ITEMS_TYPES.PASSWORD).setAttributes({ '[forceFormMode]': true })
      ],
      {},
      'Login'
    )
      .subscribe(
        (data: any) => {
          this.loginDataSubmitted(data);
        }
      );
  }

  loginDataSubmitted(submittedData) {
    this.auth(submittedData.payload.formData.loginId, submittedData.payload.formData.password);
  }
}
